// extracted by mini-css-extract-plugin
export const inline = "PricePromo-module--inline--3WtW-";
export const promo = "PricePromo-module--promo--3PpdE";
export const list = "PricePromo-module--list--4FbAv";
export const icon = "PricePromo-module--icon--1I3Pi";